import { Component, Story, Knobs } from './DocTypes';

const BasicStoryKnobs: Knobs = {
  height: { default: '300px', editor: 'textbox', delimiter: '\n  ' },
  width: { default: '375px', editor: 'textbox', delimiter: '\n  ' },
  'min-height': { default: '100px', editor: 'textbox', delimiter: '\n  ' },
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const BasicStoryKnobsReact: Knobs = {
  height: { default: '300px', editor: 'textbox', delimiter: '\n  ' },
  width: { default: '375px', editor: 'textbox', delimiter: '\n  ' },
  minHeight: { default: '100px', editor: 'textbox', delimiter: '\n  ' },
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const BasicStory: Story = {
  title: 'Basic',
  description: 'A basic modal for mobile apps',

  coreComponent_v3: {
    html: `<div style="min-width: 375px; display: flex; height: 100%; flex-direction: column; justify-content: flex-end;">
    <tag3-mobile-vertical-slider-panel {{...knobs}}>
        <div style='padding: 5px 20px'>
          A panel that slides up and down.
        </div>
    </tag3-mobile-vertical-slider-panel>
</div>
`,
    knobs: BasicStoryKnobs,
  },
  reactWrapper_v3: {
    jsx: `<div style={{ minWidth: "375px", display: "flex", height: "100%", flexDirection: "column", justifyContent: "flex-end" }}>
    <Tag3MobileVerticalSliderPanel {{...knobs}}>
      <div style={{padding: '5px 20px', display: 'flex', flexDirection: 'column'}}>
        A panel that slides up and down.
      </div>
    </Tag3MobileVerticalSliderPanel>
</div>`,
    knobs: BasicStoryKnobsReact,
  },
};

export const TagMobileVerticalSliderPanelDocs: Component = {
  type: 'component',
  name: 'mobile-vertical-slider-panel',
  description: 'Renders a panel that the user can slide up and down.',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'height',
      description: 'total expandable height of the slider',
      type: 'string',
      default: '200px',
    },
    {
      name: 'width',
      description: 'slider width',
      type: 'string',
      default: '200px',
    },
    {
      name: 'minHeight',
      description: 'minimum slider height (including header)',
      type: 'string',
      default: '50px',
    },
    {
      name: 'colour-scheme',
      description:
        'Dark mode (theme) control. Undefined for normal browser control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light',
    },
    {
      name: 'device',
      description: 'Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'mobile',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [BasicStory],
};
